import el from "@cypherpotato/el";

export function CenteredCard(...children) {
    return el("div.page-centered-card",
        ...children);
}

export function CenteredCardHeader(title, description, ...children) {
    return el("div.page-centered-card-header",
        el("h2", title),
        el("p", description),
        ...children);
}

export function CenteredCardContent(...children) {
    return el("div.page-centered-card-content",
        ...children);
}

export function CenteredCardNavigation(...children) {
    return el("div.page-centered-card-header.navigation",
        ...children);
}

export function CenteredCardImage(src) {
    return el("img.page-centered-card-image", {
        src
    });
}